import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceFunctionDetailVideoChat',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,
      processing: false,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,
      serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
      values: state => state.serviceFunctionDetail.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // input
    inpCalendarEvent: {
      get () {
        return this.values.inpCalendarEvent
      },
      set (value) {
        this.setInputValue({
          key: 'inpCalendarEvent',
          value: value
        })
      }
    },
    inpCalendarGarbage: {
      get () {
        return this.values.inpCalendarGarbage
      },
      set (value) {
        this.setInputValue({
          key: 'inpCalendarGarbage',
          value: value
        })
      }
    },

    // validate
    formIsValid () {
      return true
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
    }),
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
    }),

    init () {
      this.loading = false
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceFunction',
        params: {
          serviceId: this.serviceUuid
        }
      })
    },

    postData () {
      this.processing = true

      // リクエストパラメータ
      let parameters = {
        serviceUuid: this.serviceUuid,
        serviceFunctionUuid: this.serviceFunctionUuid,
        request: {
          calendarSetting: {
            eventsCalendarFlg: this.inpCalendarEvent ? 1 : 0,
            garbageDaysCalendarFlg: this.inpCalendarGarbage ? 1 : 0,
          },
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.functionName + '情報の登録',
              body: this.functionName + '情報を登録しました。',
            })

            // 一覧へリダイレクト
            this.turnBack()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // confirm
        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.functionName + '情報を登録しますか？'
        })
      }
    },
  }
}